import { render, staticRenderFns } from "./RadioboxMarked.vue?vue&type=template&id=4de20f68&"
import script from "./RadioboxMarked.vue?vue&type=script&lang=js&"
export * from "./RadioboxMarked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de20f68')) {
      api.createRecord('4de20f68', component.options)
    } else {
      api.reload('4de20f68', component.options)
    }
    module.hot.accept("./RadioboxMarked.vue?vue&type=template&id=4de20f68&", function () {
      api.rerender('4de20f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/RadioboxMarked.vue"
export default component.exports